/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `EventCreationSaveSection` for the Caintra Connect frontend.
 * @module components/EventCreation/EventCreationSaveSection
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import { Button, CircularProgress } from "@mui/material";
import { ReactComponent as SaveIcon } from "../../assets/icons/CompanyEditPage/SaveIcon.svg";

const EventCreationSaveSection = ({
  t,
  styles,
  loading,
  saving,
  isSaveDisabled,
}) => (
  <div className={styles.saveSectionContainer}>
    <div className={styles.saveSectionContent}>
      <div className={styles.messageContainer}>
        {t("pages.eventCreation.publishInstructions")}
      </div>
      <Button
        type="submit"
        variant="contained"
        className={styles.saveButton}
        disabled={isSaveDisabled}
        startIcon={loading || saving ? null : <SaveIcon />}
      >
        {loading || saving ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          t("pages.eventCreation.publishEvent")
        )}
      </Button>
    </div>
  </div>
);

export default EventCreationSaveSection;
